export const AFRR_LIMIT_VALUE_DIVISOR = 100
export const SPOT_PRICE_LIMIT_VALUE_DIVISOR = 10000
export const FFR_LIMIT_VALUE_DIVISOR = 1000000
